import logoMobilawy from "./assets/images/logo-mobilawy.svg";
import logoMobil from "./assets/images/logo-mobil.svg";
import badgeAppStore from "./assets/images/badge-app-store.svg";
import badgeGooglePlay from "./assets/images/badge-google-play.svg";
import phoneExplore from "./assets/images/phone-explore.svg";
import phoneHome from "./assets/images/phone-home.svg";
import "./App.scss";

function App() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="App">
      <header className="site-header">
        <img
          src={logoMobilawy}
          className="site-header__mobilawy"
          alt="Mobilawy"
        />
        <img src={logoMobil} className="site-header__mobil" alt="Mobil" />
      </header>

      <main className="hero">
        <div className="hero__text">
          <h1>Your Complete Automotive Companion.</h1>
          <p className="hero__lead">
            With Mobilawy, you earn points that can be redeemed for exciting
            rewards on Mobil products. Mobilawy is more than just a loyalty
            program—it's your complete automotive companion.
          </p>
          <p>
            Easily manage your vehicles, access roadside assistance whenever
            you need it, and explore the aftermarket. Connect with trusted
            automotive service providers for maintenance and repairs, and
            locate nearby Mobil stations for all your fueling and service
            needs. Stay up-to-date with the latest offers and promotions
            designed just for you.
          </p>
          <p className="hero__closing">
            Enhance your driving experience with Mobilawy and unlock a world of
            rewards, convenience, and premium automotive services and resources.
          </p>
          <div className="hero__badges">
            <a
              href="https://apps.apple.com/us/app/mobilawy/id1624508976"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={badgeAppStore} alt="Download on the App Store" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.mobilawy.consumer&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={badgeGooglePlay} alt="Get it on Google Play" />
            </a>
          </div>
        </div>
        <div className="phones">
          <img
            src={phoneExplore}
            className="phone phone--back"
            alt="Mobilawy app Explore screen with nearby Mobil stations and maintenance centers"
          />
          <img
            src={phoneHome}
            className="phone phone--front"
            alt="Mobilawy app home screen with points balance, services and offers"
          />
        </div>
      </main>

      <footer className="site-footer">
        <img src={logoMobil} className="site-footer__logo" alt="Mobil" />
        <p>
          {/* NOTE: 2025 is just a fallback year just in case the current year cannot be gotten for any resaon. */}
          © Copyright {currentYear || "2025"} Exxon Mobil Corporation. All
          Rights Reserved.
        </p>
        <nav className="site-footer__links" aria-label="Legal">
          <a
            href={`${process.env.PUBLIC_URL}/privacy-policy.html`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href={`${process.env.PUBLIC_URL}/terms-and-conditions.html`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms &amp; Conditions
          </a>
        </nav>
      </footer>
    </div>
  );
}

export default App;
